import { Skeleton, Stack, Typography } from "@mui/material";

interface InsightWorkspaceLoadingSkeletonProps {
  loadingText: string;
}

export function InsightWorkspaceLoadingSkeleton({
  loadingText,
}: InsightWorkspaceLoadingSkeletonProps) {
  return (
    <Stack spacing={2} sx={{ py: 1 }}>
      <Typography variant="body2" color="text.secondary" fontWeight={600}>
        {loadingText}
      </Typography>
      <Stack spacing={1}>
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} variant="rounded" height={40} />
        ))}
      </Stack>
      <Stack spacing={1.25} sx={{ mt: 1 }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Stack key={i} direction="row" spacing={1} alignItems="center">
            <Skeleton variant="circular" width={18} height={18} />
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="rounded" height={10} sx={{ flex: 1 }} />
            <Skeleton variant="text" width={44} />
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}
